import { render, staticRenderFns } from "./domaine-de-la-janasse.vue?vue&type=template&id=47b7b33c&scoped=true"
import script from "./domaine-de-la-janasse.vue?vue&type=script&lang=js"
export * from "./domaine-de-la-janasse.vue?vue&type=script&lang=js"
import style0 from "./domaine-de-la-janasse.vue?vue&type=style&index=0&id=47b7b33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7b33c",
  null
  
)

export default component.exports